import { NavLink, Outlet } from 'react-router-dom';
import {
  BookOpen,
  CalendarDays,
  GraduationCap,
  LineChart,
  ScrollText,
  UserSquare2,
  Users,
} from 'lucide-react';
import { cn } from '@/lib/utils';
import { t } from '@/locales/i18n';

const ITEMS = [
  { to: '/formation', label: t('formation.nav.dashboard'), icon: GraduationCap, end: true },
  { to: '/formation/catalogue', label: t('formation.nav.catalogue'), icon: BookOpen, end: false },
  { to: '/formation/sessions', label: t('formation.nav.sessions'), icon: CalendarDays, end: false },
  {
    to: '/formation/inscriptions',
    label: t('formation.nav.inscriptions'),
    icon: Users,
    end: false,
  },
  {
    to: '/formation/formateurs',
    label: t('formation.nav.formateurs'),
    icon: UserSquare2,
    end: false,
  },
  {
    to: '/formation/evaluations',
    label: t('formation.nav.evaluations'),
    icon: ScrollText,
    end: false,
  },
  { to: '/formation/rapports', label: t('formation.nav.rapports'), icon: LineChart, end: false },
];

export function FormationLayout(): JSX.Element {
  return (
    <div className="flex h-full flex-col">
      <div className="border-b border-border bg-card">
        <div className="flex items-end gap-1 overflow-x-auto px-4">
          {ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-2 whitespace-nowrap border-b-2 px-3 py-3 text-sm transition-colors',
                  isActive
                    ? 'border-primary text-primary'
                    : 'border-transparent text-muted-foreground hover:border-border hover:text-foreground',
                )
              }
            >
              <item.icon className="h-4 w-4" />
              {item.label}
            </NavLink>
          ))}
        </div>
      </div>
      <div className="scrollbar-thin flex-1 overflow-y-auto bg-secondary/20">
        <Outlet />
      </div>
    </div>
  );
}
